export default {
  // 总览
  overview: '首页',
  industry: '解决方案',
  market: '算法超市',
  contact: '联系我们',
  login: '登录',
  register: '注册',
  //算法超市
  detection: '人脸检测',
  landmarks: '人脸关键点',
  comparison: '人脸对比',
  album: '相册聚类',
  emotion: '情绪识别',
  attributes: '人脸属性',
  age: '年龄识别',
  mask: '口罩检测',
  portrait: '人像分割',
  beauty: '颜值测评',
  head: '头肩检测',
  gender: '性别识别',

  body: '人体检测',
  bodyAttributes: '人体属性',
  skeleton: '人体骨骼点',
  hand: '手势关键点',
  recognition: '手势识别',
  crowd: '人群密度',
  driving: '驾驶行为分析',
  reflective: '反光衣检测',
  fight: '打架斗殴',
  matting: '人体抠像',

  general: '通用文字识别',
  handwritten: '手写文字识别',
  bank: '银行卡识别',
  business: '营业执照识别',
  License: '车牌识别',
  table: '表格识别',
  office: '办公文档识别',
  qr: '二维码识别',
  invoice: '发票信息提取',
  driver: '驾驶证识别',

  image: '通用识别',
  plant: '植物识别',
  animal: '动物识别',
  car: '车型识别',
  vehicle: '车辆检测',
  food: '菜品识别',
  fruit: '果蔬识别',
  fire: '烟火识别',
  smoke: '烟雾识别',
  landmark: '地标识别',
  pet: '宠物对比',

  super: '高清复原',
  Inpainting: '图像消除',
  dehazing: '图像去雾',
  style: '图像风格迁移',
  anime: '人像动漫化',
  search: '图像搜索',
  product: '商品搜索',
  generation: '图像生成',
  color: '图像色彩增强',
  black: '黑白图像上色',

  face: '人脸识别',
  bodyRecognition: '人体识别',
  characterRecognition: '文字识别',
  imageRecognition: '图像识别',
  imageTechnology: '图像技术',

  // 轮播图
  title: '智能AI视觉检测平台',
  description: '让缺陷无处藏身，行业领军只选！',
  start: '开始使用',
  learnMore: '了解更多',
  aIot: 'AIoT智联万物',
  twoDescription: '匠心打造全球领先的智能化解决方案',

  audioTech: '语音技术',
  denoising: '语音增强',
  voice: '语音唤醒',
  speech: '语音识别',
  synthesis: '语音合成',
  voiceprint: '声纹识别',

  homepage: {
    experienceTitle: '体验标题',
    customUpload: '自定义上传',
    analysis: '分析',
    applicationTitle: '应用标题',
    application1: '应用内容 1',
    application2: '应用内容 2',
  },
  messages: {
    uploadImageFormat: '请上传 JPG/PNG 格式的图片',
    imageFileTooLarge: '图片文件过大',
    imageSizeLimit: '请将图片大小控制在 2MB 内',
    tooFrequentOperations: '操作过于频繁',
    tryAgainLater: '请稍后再试',
    noFaceDetected: '未检测到人脸',
    reselectImage: '请确保上传图像包含人像，并确保人脸正视画面',
    uploadLocalImage: '*请上传一张本地图片，体验功能。',
  },
  buttons: {
    confirm: '确定',
    localUpload: '本地上传图片',
  },

  generalText: '通用文字识别技术能够将图片中的文字转换为可编辑文本',
  algorithmic: '算法能力',
  faceAgeDec: '年龄识别是利用图像分析等技术来估算一个人年龄的方法。',
  customer: '顾客属性分析',
  camera: '美颜相机',
  ageText: '年龄',
  genderDec: '性别识别是利用图像分析等技术来判断一个人性别的方法。',
  genderText: '性别',
  emotionDec: '情绪识别是利用图像分析等技术来判断一个人情绪的方法。',
  emotionText: '情绪',
  richness: '识别类型丰富',
  analysis: '支持实时分析',
  comparisonDec:
    '人脸比对利用算法分析、比较不同人脸图像的特征点，以确定身份相似度的过程。',
  access: '门禁系统',
  security: '安防监控',
  petDec: '通过对比两种宠物图片的特征判断是否为同一只宠物。',
  insurance: '宠物保险',
  facial: '面部识别',
  expression: '表情分析',
  bodyDec: '人体检测技术用于识别图像或视频中的人体轮廓与位置。',
  warning: '安全监测预警',
  bodyText: '性别',
  skeletonDec:
    '人体骨骼点描述：头、颈、肩、肘、腕、手、胸、腰、髋、膝、踝、足等连接处。',
  fallDown: '摔倒检测',
  motion: '动作捕捉技术',
  bodyAttributesDec:
    '人体属性识别描述：通过图像分析性别、年龄、姿态、衣着及行为等特征。',
  crowd: '人群属性识别',
  retail: '零售顾客分析',
  satisfaction: '满意度分析',
  flow: '统计人流',
  advertisement: '广告投放',
  keyIndex: '关键指标',
  indexDec: '在算法部署中，硬件平台的选择直接影响效率与成本',
  face_tips: '目前页面最多显示10个结果，使用 SDK 可以全部显示',
  readAgree: '我已阅读并同意',
  userAgree: '用户协议',
  privacyPolicy: '隐私政策',
  and: '和',
  qr: '二维码识别',
  qrDec: '通过设备快速读取二维码信息的技术',
  qrResult: '结果',
  pay: '扫码支付',
  plate: '车牌识别',
  plateDec: '通用文字识别技术能够将图片中的文字转换为可编辑文本',
  parking: '无人值守停车场缴费',
  traffic: '交通违法监控',
  vehicle: '车辆检测',
  vehicleDec: '利用技术手段识别并分析道路上车辆的情况。',
  flow: '道路车流统计',
  error: '对不起，你访问的页面不存在',
  backHome: '返回主页',
  qrEmpty: '未检测到二维码',
  selectQr: '请重新选择，确保二维码正对画面',
  plateEmpty: '未检测到车牌',
  selectPlate: '请重新选择，确保车牌正对画面',
  vehicleEmpty: '未检测到车辆',
  selectVehicle: '请重新选择，确保车辆正对画面',
  human: '人体抠像',
  humanDec: '精准提取视频或图像中的人物轮廓并移除背景',
  broadcast: '虚拟演播',
  video: '视频会议',
  audio: '语音降噪',
  audioDec: '智能消除背景噪音，增强人声清晰度。',
  before: '降噪前',
  after: '降噪后',
  noise: '耳机降噪',
  restore: '高清复原',
  restoreDec: '恢复低分辨率图像或视频的细节，提升清晰度。',
  film: '影视修复',
  animation: '人物动漫化',
  animationDec: '将真实人物图像转换成动漫风格的处理过程。',
  character: '角色开发',
  whiteImage: '黑白图像上色',
  whiteImageDec: '通过算法为黑白图像添加色彩，使其更加生动。',
  oldPhoto: '老照片修复',
  handKey: '手势关键点',
  handKeyDec: '识别并追踪手部动作的关键位置点，用于交互控制。',
  game: '体感游戏',
  density: '人群密度',
  densityDec: '通过技术手段监测和分析特定区域内人群的数量与分布。',
  shopping: '商场管理',
  person: '人',
  handleEmpty: '未检测到手势',
  selectHand: '请重新选择，确保手势正对画面',
  selectVehicle: '请重新选择，确保车辆正对画面',
  helmet: '安全帽',
  maskTest: '口罩检测',
  maskTestDec: '通过图像识别技术判断人员是否正确佩戴口罩。',
  wearApply: '医用用品佩戴检测',
  maskEmpty: '未检测到口罩',
  selectMask: '请重新选择，确保口罩正对画面',
  behavior: '驾驶行为分析',
  behaviorDec: '通过图像识别技术分析驾驶员操作及状态。',
  behaviorApply: '疲劳驾驶预警',
  helmet: '安全帽检测',
  helmetDec: '通过图像识别技术判断人员是否正确佩戴安全帽。',
  helmetApply: '工地安全管理',
  headShoulder: '头肩检测',
  headShoulderDec: '通过图像识别技术识别人体头部与肩部位置信息。',
  headShoulderApply: '工地安全管理',
  fire: '烟火识别',
  fireDec: '通过图像技术分析并定位火源位置。',
  fileApply: '火灾报警',
  helmetEmpty: '未检测到安全帽',
  selectHelmet: '请重新选择，确保安全帽正对画面',
  fireEmpty: '未检测到火焰',
  selectFire: '请重新选择，确保火焰正对画面',
  businessDec: '通过图像识别技术自动提取证件信息，提升审核效率。',
  animalEmpty: '未检测到动物',
  selectAnimal: '请重新选择，确保动物正对画面',
  dishesEmpty: '未检测到菜品',
  selectDishes: '请重新选择，确保菜品正对画面',
  vegetablesEmpty: '未检测到果蔬',
  selectVegetables: '请重新选择，确保果蔬正对画面',
  businessApply: '企业注册',
  bankDec: '通过图像识别技术自动提取银行卡信息。',
  bankApply: '银行转账',
  invoiceDec: '通过图像识别技术自动提取发票上的关键信息。',
  invoiceApply1: '企业报销',
  invoiceApply2: '税务审计',
  driverDec: '通过图像识别技术自动提取驾驶证信息。',
  driverApply: '交警查证',
  depth: '深度估计',
  odd: '奇偶合帧',
  moution: '运动成像',
  albumApply: '相册图片分类',
  albumDec: '通过聚类算法将相册内相似的相片进行聚类。',
  beautyDec: '颜值测评技术对于输入的面部图像进行打分',
  beautyApply1: '美颜相机',
  beautyApply2: '颜值打分',
  recognitionDec: '通过图像识别技术获取用户对应手势以进行对应操作。',
  recognitionApply: '商场管理',
  reflectiveDec: '通过图像识别技术判断人员是否穿反光衣',
  reflectiveApply: '工地安全管理',
  tableApply1: '纸质财税报表识别',
  tableApply2: '纸质登记表识别',
  control: '控制台',
  logout: '退出',
  interactive: '交互',
  hot: '热门',
  carDec: '通过图像技术对车辆具体型号进行分类。',
  carApply1: '车辆交易',
  carApply2: '智慧车险',
  smokeDec: '通过图像技术分析并定位烟雾位置。',
  smokeApply1: '野火报警',
  smokeApply2: '园区火灾报警',
  plantDec: '通过图像技术对不同植物进行分类。',
  plantApply1: '国家保护动物保护',
  plantApply2: '农业有害生物检测',
  fruitDec: '通过图像技术对不同果蔬进行分类。',
  fruitApply1: '果蔬搭配推荐',
  fruitApply2: '营养成分统计',
  foodDec: '通过图像技术对不同菜品进行分类。',
  foodApply1: '菜品结算',
  foodApply2: '热量计算',
  landmarkDec: '通过图像技术对不同地标进行分类。',
  landmarkApply1: '地标搜索',
  landmarkApply2: '相册地标归类',
  productApply1: '拍照搜索商品',
  productApply2: '商品找相似',
  InpaintingApply1: '路人消除',
  InpaintingApply2: '水印消除',
  dehazingApply1: '雾天智驾',
  dehazingApply2: '照片后期去雾',
  colorApply1: '设计素材美化',
  colorApply2: '照片调色',
  generationApply1: '文案配图生成',
  generationApply2: 'logo生成',
  styleApply1: '混合风格图片创作',
  styleApply2: '图片油画化',
  imageDec: '通过图像识别技术获取当前图片占比最多的几个元素。',
  imageApply1: '用户场景判断',
  oddDec: '将奇数场与偶数场图像数据合并为一帧。',
  oddApply: '提升画面流畅',
  depthApply: '组合辅助驾驶导航',
  handwrittenApply1: '笔记电子化',
  handwrittenApply2: '智能阅卷',
  gestureEmpty: '未检测到手势',
  selectGesture: '请重新选择，确保手势正对画面',
  vestEmpty: '未检测到反光衣',
  selectVest: '请重新选择，确保反光衣正对画面',
  quectelQr: '微信公众号: 移远通信',
  handwrittenDec: '通用文字识别技术能够将手写文字转换为可编辑文本。',
  personalEmpty: '未检测到行人',
  selectPersonal: '请重新选择，确保行人正对画面',
  bodyEmpty: '未检测到人体',
  selectBody: '请确保上传图像包含人体，并确保人体正视画面',
  depthDec: '通过图像识别技术获取场景中物体的距离信息。',
  smoking: '吸烟检测',
  smokingDec: '通过图像识别吸烟行为的技术。',
  smokingApply: '禁烟场所监测',
  smokeEmpty: '未检测到吸烟',
  selectSmoke: '请重新选择，确保吸烟正对画面',
  animalDec: '通过图像技术对不同动物进行分类。',
  animalApply: '野生动物检测',
  moutionDec: '电子图像防抖是一种通过软件算法实现防抖的技术。',
  moutionApply1: '运动相机',
  moutionApply2: '行车记录仪',
  generator: '生成式AI',
  textToImage: '文生图',
  LargeLanguage: '检索增强生成',
  multiModal: '多模态',
  imageUnderstand: '图像理解',
  imageSearch: '语义图像搜索',
  contactUs: '联系我们',
  phoneIncorrect: '手机号格式不正确',
  emailIncorrect: '邮箱格式不正确',
  leave: '请留下您的需求和问题，我们将会主动与您联系',
  consultant: '请留下您的需求和问题，我们的售前顾问会主动与您联系',
  phone: '电话',
  email: '邮箱',
  application: '您的应用场景和技术能力要求',
  company: '公司名称',
  submit: '提交',
  tellUs: '请告诉我们您的需求，我们将会与您联系',
  transfer: '风格迁移',
  imageInpaint: '图像修复',
  function: '功能咨询',
  textToImageDec: '天空之城,一个城堡,达利,油画,飘逸感,玫瑰色的天空',
  imageToTextDec: '请帮我找出图中的狗。',
  suppport: '支持的平台',
  smart: '所有Smart平台',
  vehicleEmpty: '未检测到车辆',
  selectVehicle: '请重新选择，确保车辆正对画面',
  thingEmpty: '未检测到物品',
  selectThing: '请重新选择，确保物品正对画面',
  techEmpty: '无法识别修复图片',
  selectTech: '请重新选择图片',
  chatbots: '智能助手与聊天机器人',
  creation: '内容创作与生成',
}
